module.exports = __webpack_public_path__ + "img/361-e28384.png";